import { Link } from "react-router-dom";
import { db } from "../../firebase";
import { useState, useEffect } from "react";

const Headerr = () => {
  const [news, setNews] = useState();

  useEffect(() => {
    const ref = db.collection("blogs/blog/posts");
    ref
      .orderBy("createdate", "desc")
      .limit(4)
      .get()
      .then((querySnapshot) => {
        let documents = [];
        querySnapshot.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id });
        });
        setNews(documents);
      });
  }, []);
  const [latest, setLatest] = useState();

  useEffect(() => {
    const ref = db.collection("blogs/blog/posts");
    ref
      .orderBy("createdate", "desc")
      .limit(1)
      .get()
      .then((querySnapshot) => {
        let documents = [];
        querySnapshot.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id });
        });
        setLatest(documents);
      });
  }, []);
  return (
    <header className="home-header">
      <div className="container">
        <h1 className="mobile">اخر الاخبار</h1>
        {latest ? (
          latest.map((late) => {
            return (
              <div key={late.id} className="image">
                <img src={late.file.src} alt="" />
                <div className="overlay">
                  <Link to={`blogs/${late.id}`}>
                    <p>{late.title}</p>
                  </Link>
                </div>
              </div>
            );
          })
        ) : (
          <div className="image">
            <div className="img skeleton"></div>
            <div className="overlay">
              <div className="skeleton-group">
                <p className="skeleton"></p>
                <p className="skeleton"></p>
              </div>
            </div>
          </div>
        )}
        <div className="header-links">
          <h1 className="pc">اخر الاخبار</h1>
          {news ? (
            news.map((neww) => {
              return <Link key={neww.id} to={`blogs/${neww.id}`}>{neww.title}</Link>;
            })
          ) : (
            <div className="load">
              <div className="skeleton latest-load"></div>
              <div className="skeleton latest-load"></div>
              <div className="skeleton latest-load"></div>
              <div className="skeleton latest-load"></div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Headerr;
